var exports = {
  "kL": "container__CJeGIj",
  "k9": "jobsHeader__Ivlv2x",
  "FC": "jobsHeading__wORwm4",
  "dc": "spinnerContainer__Qcvmvr",
};

module.exports = exports;
